export default class MaterialGallery {
    constructor($element) {
        this.$element = $element;

        this.data = {};
        this.page = 1;
        this.perView = 18;

        this.$materialsWrap = this.$element.find('.js-materials-wrap');
        this.$loadMore = this.$element.find('.js-load-colours');
        this.$resetColours = this.$element.find('.js-reset-colours');

        this.loadData();
        this.bindEvents();
    }

    loadData() {
        let $json = this.$element.find(".js-material-data");

        if ($json.length > 0) {
            try {
                this.data = JSON.parse($json.text());
            } catch (e) {
                console.warn("Couldn't load data from page", e);
            }
        }
    }

    bindEvents() {
        let me = this;

        this.$loadMore.on('click', () => {
            this.loadMore();
            return false;
        });

        this.$resetColours.on('click', () => {
            this.resetColours();
            return false;
        });
    }

    loadMore() {
        if (this.data.length <= 0) {
            console.log("Cannot load more data");
            return;
        }

        let startIndex = (this.perView * this.page);
        let endIndex = Math.min(this.data.length, startIndex + this.perView);

        this.data.slice(startIndex, endIndex).forEach((material, index) => {
            this.$materialsWrap.append(this.buildMaterial(material, index));
        });

        if (endIndex >= this.data.length) {
            this.showResetButton();
        }

        this.page++;
    }

    buildMaterial(data, index) {
        return (
            eotwJSXFactory('div', {className: "tile-columns__column a__i a__i--fade-in-up a__i--dur-600 a__i--delay-" + Math.floor(index / 6) * 200}, [
                eotwJSXFactory('div', {className: "tile tile--colour"}, [
                    eotwJSXFactory('div', {className: "tile__img", unsafeHtml: data.image}),
                    eotwJSXFactory('div', {className: "tile__body"}, [
                        eotwJSXFactory('p', {className: "tile__text"}, [data.colour.replace('-', ' ')])
                    ])
                ])
            ])
        )
    }

    showResetButton() {
        this.$resetColours.show();
        this.$loadMore.hide();
    }

    hideResetButton() {
        this.$resetColours.hide();
        this.$loadMore.show();
    }

    resetColours() {
        this.$materialsWrap.html('');
        this.page = 0;
        this.loadMore(this.data);
        this.hideResetButton();
    }
}
